import { render, staticRenderFns } from "./jobDetailMobile.vue?vue&type=template&id=2b9cc7dc&scoped=true"
import script from "./jobDetailMobile.vue?vue&type=script&lang=js"
export * from "./jobDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./jobDetailMobile.vue?vue&type=style&index=0&id=2b9cc7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9cc7dc",
  null
  
)

export default component.exports